import * as actionTypes from './actionTypes';
import axios from "axios";
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const signupEmployee=(request,token)=>async dispatch=>{
    dispatch({
        type:actionTypes.SIGNUP_EMPLOYEE_START
    })
    const options={
        url:`${api}/auth/employee/signup`,
        method:'POST',
        headers:{
            'Authorization':`Bearer ${token}`
        },
        data:request
    }
    await axios(options)
            .then(response=>dispatch({
                type:actionTypes.SIGNUP_EMPLOYEE_SUCCESS,
                payload:response.data
            }))
            .catch(error=>dispatch({
                type:actionTypes.SIGNUP_EMPLOYEE_FAIL,
                payload:getMessage(error)
            }))
}